import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchAbTest = async (id: number) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id,
    },
    query: graphql(`
      query fetchAbTest($id: Float!) {
        abTest(id: $id) {
          id
          name
          type
          description
          status
          startDate
          endDate
          deactivateDate
          createdAt
          updatedAt
          delay
          endAfterNumUsers
          successConditions
          data
          exclusiveKeys
          abTestGroups {
            createdAt
            data
            description
            groupLabel
            groupType
            groupTarget
            associatedObjectType
            associatedObjectId
            winner
            isActiveForAssignment
            id
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.abTest;
};
